export default "__VITE_ASSET__3Lm1etg4__"